import { BaseApi } from '@/main/baseApi';

import { DMS_MODULE, API_NAME, buttons } from './constants';

function reportUrlByName(routeName: string): string {
	return buttons.find((item) => item.routeName === routeName)?.api!;
}

class SestavyApi extends BaseApi {
	constructor() {
		super(DMS_MODULE, API_NAME);
	}

	getReport(routeName:string, filter: {}) {
		const apiName = reportUrlByName(routeName);
		return this.fetchPdf(`${this.apiPath}${apiName}`, filter);
	}

	getAccessFlag() {
		return this.fetch(`${this.apiPath}GetAccessFlag`);
	}
}


export const apiProvider = new SestavyApi();
